export const classes = {
  condensedEvent:
    'flex items-center gap-[6px] w-full pl-[4px] pr-[8px] py-[4px] rounded-full cursor-pointer',
  condensedDescription:
    'flex-1 min-w-0 text-[11.5px] font-semibold tracking-[0.02rem] truncate',
  event:
    'size-full rounded-lg px-3 py-2 overflow-hidden cursor-pointer transition-all',
  open: 'bg-[#e6e4fc] text-[#4338ca] dark:bg-[#818cf8]/[0.26] dark:text-[#c7cdff]',
  closed:
    'bg-black/[0.06] text-taupe-1/70 line-through dark:bg-white/[0.08] dark:text-mauve-3/70',
  time: 'text-[12px] font-semibold',
  title: 'flex justify-between gap-[6px] mb-[2px]',
  name: 'text-[12px] font-semibold opacity-[0.92] truncate',
  description: 'text-[12.5px] font-medium',
};
